/* */
/**
 * @module actions/Dropdown
 */
import { createAction } from 'typesafe-actions';

import actions from '../constants/ViewActions';

interface OpenDropdownParams {
  menuType: $TSFixMe;
  config: $TSFixMe;
}

interface OpenDropdownPayload {
  dropdownConfiguration: [OpenDropdownParams['menuType'], OpenDropdownParams['config']];
}

export const openDropdown = createAction(
  actions.OPEN_DROPDOWN,
  (dropdownConfiguration: OpenDropdownParams) => ({
    dropdownConfiguration: [dropdownConfiguration.menuType, dropdownConfiguration.config],
  }),
)<OpenDropdownPayload>();
export type OpenDropdownAction = ReturnType<typeof openDropdown>;

export const closeDropdown = createAction(actions.CLOSE_DROPDOWN)();
export type CloseDropdownAction = ReturnType<typeof closeDropdown>;
